<template>
  <div
    class="h-full w-full bg-[#F7F5FF] md:flex"
    id="appContent"
    :class="{
      '[&_.mobile-status-padding]:pt-12 [&_.mobile-bottom-padding]:pt-8 [&_.mobile-status-padding-mt]:mt-12 need-mobile-app-padidngs':
        $stores.shared?.state?.isAndroidApp
    }"
  >
    <!-- desktop navigation -->
    <DesktopNavs
      v-show="
        !['login', 'register', 'welcome'].includes($route.name) && $route.name
      "
    />

    <Transition
      mode="out-in"
      appear
      enter-active-class="transition-opacity duration-500"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      duration="200"
    >
      <div
        class="w-full h-full"
        :class="{
          'md:ml-64': !['login', 'register', 'welcome'].includes($route.name) && $route.name
        }"
        :key="$route.fullPath"
      >
        <slot></slot>
      </div>
    </Transition>

    <LinksFab />
    <!-- mobile bottom navigation -->
    <div
      v-show="
        !['login', 'register', 'welcome'].includes($route.name) && $route.name
      "
    >
      <BottomNavs class="fixed bottom-0" />
    </div>
    <div class="hidden">
      <ImgComponent avatar defaultAvatarStyle="miniavs" src="you" alt="" />
    </div>
  </div>
</template>
